import type { Messages } from '@/types'

// Placeholder Dutch translations - to be completed with proper translations
const messages: Messages = {
    common: {
        actions: {
            add: 'Toevoegen',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            cancel: 'Annuleren',
            back: 'Terug',
            save: 'Opslaan',
            update: 'Bijwerken',
            reset: 'Herstellen',
            refresh: 'Vernieuwen',
            backToList: '@:common.back naar lijst',
            resetDefaults: '@:common.reset naar standaardwaarden',
            confirm: 'Bevestigen',
            proceed: 'Doorgaan',
            close: 'Sluiten',
            apply: 'Toepassen',
            search: 'Zoeken',
            filter: 'Filteren',
            clear: 'Wissen',
            select: 'Selecteren',
            upload: 'Uploaden',
            download: 'Downloaden',
            view: 'Bekijken',
            sort: 'Sorteren',
            seeMore: 'Meer zien'
        },
        status: {
            success: 'Succes',
            error: 'Fout',
            loading: 'Laden...'
        },
        messages: {
            deleteConfirm: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
            generalError: 'Er ging iets mis! Probeer het opnieuw',
            addSuccess: 'Record succesvol toegevoegd!',
            updateSuccess: 'Record succesvol bijgewerkt!',
        },
        placeholder: {
            avatar: '?'
        },
        labels: {
            loading: 'Laden',
            noResults: 'Geen resultaten gevonden',
            noData: 'Geen gegevens beschikbaar',
            selected: 'Geselecteerd',
            required: 'Verplicht',
            optional: 'Optioneel',
            search: 'Zoeken...',
            filter: 'Filteren...',
            from: 'Van',
            to: 'Tot',
            date: 'Datum',
            status: 'Status',
            item: 'Item {index}',
            addItem: 'Item Toevoegen',
            removeItem: 'Item Verwijderen',
            skipToMain: 'Ga naar hoofdinhoud',
            openNavigation: 'Navigatie openen',
            closeNavigation: 'Navigatie sluiten',
            mainNavigation: 'Hoofdnavigatie',
            moveUp: 'Omhoog Verplaatsen',
            moveDown: 'Omlaag Verplaatsen'
        },
        errors: {
            upload: 'Bestand uploaden mislukt',
            download: 'Bestand downloaden mislukt',
            generic: 'Er is een fout opgetreden',
            notFound: 'Niet gevonden',
            unauthorized: 'Onbevoegde toegang',
            validation: 'Controleer uw invoer'
        },
        validation: {
            required: 'Dit veld is verplicht',
            email: 'Ongeldig e-mailadres',
            minLength: 'Minimale lengte is {length}',
            maxLength: 'Maximale lengte is {length}',
            min: 'Minimumwaarde is {min}',
            max: 'Maximumwaarde is {max}',
            matches: 'Ongeldig formaat',
            unique: 'Waarde moet uniek zijn',
            confirm: 'Wachtwoorden komen niet overeen'
        }
    },
    pages: {
        users: {
            title: 'Gebruikers',
            description: 'Beheer systeemgebruikers',
            actions: {
                invite: 'Gebruiker Uitnodigen',
                resetPassword: 'Wachtwoord Herstellen'
            }
        },
        settings: {
            title: 'Instellingen',
            actions: {
                resetDefaults: 'Herstellen naar standaardwaarden'
            }
        },
        reports: {
            title: 'Rapporten',
            description: 'Rapporten genereren en downloaden',
            actions: {
                generateReport: 'Rapport Genereren',
                downloadCsv: 'CSV Downloaden',
                startDate: 'Startdatum',
                endDate: 'Einddatum',
                apps: 'Apps',
            },
            error: {
                generation: 'Rapport genereren mislukt',
                download: 'Rapport downloaden mislukt'
            }
        }
    },
    navigation: {
        home: 'Home',
        library: 'Bibliotheek',
        search: 'Zoeken',
        login: 'Inloggen',
        signInToGetPremium: 'Premium krijgen',
        subscribe: 'Abonneren',
        support: 'Ondersteuning',
        settings: 'Instellingen',
        logout: 'Uitloggen'
    },
    settings: {
        title: 'Instellingen',
        description: 'Beheer uw accountinstellingen, voorkeuren en profielinformatie.',
        sections: 'Instellingssecties',
        menu: {
            profile: 'Profiel',
            account: 'Account',
            general: 'Algemeen',
            purchases: 'Aankopen',
            activity: 'Activiteit'
        },
        profile: {
            title: 'Profiel',
            changeImage: 'Afbeelding Wijzigen',
            updateProfile: 'Profiel Bijwerken',
            changePassword: 'Wachtwoord Wijzigen',
            updatePassword: 'Wachtwoord Bijwerken',
            fields: {
                fullName: 'Volledige Naam',
                emailAddress: 'E-mailadres',
                dateOfBirth: 'Geboortedatum',
                currentPassword: 'Huidig Wachtwoord',
                newPassword: 'Nieuw Wachtwoord',
                confirmNewPassword: 'Bevestig Nieuw Wachtwoord'
            },
            toasts: {
                imageUpdated: 'Afbeelding Bijgewerkt',
                imageUpdatedMessage: 'Uw profielafbeelding is succesvol bijgewerkt',
                uploadFailed: 'Upload Mislukt',
                profileUpdated: 'Profiel Bijgewerkt',
                profileUpdatedMessage: 'Uw profiel is succesvol bijgewerkt',
                passwordUpdated: 'Wachtwoord Bijgewerkt',
                passwordUpdatedMessage: 'Uw wachtwoord is succesvol bijgewerkt',
                passwordError: 'Wachtwoordfout',
                passwordMismatch: 'Wachtwoorden komen niet overeen',
                passwordTooWeak: 'Wachtwoord is te zwak'
            }
        },
        account: {
            title: 'Account',
            accountInformation: 'Accountinformatie',
            emailAddress: 'E-mailadres',
            memberSince: 'Lid sinds',
            redeemPromoCode: 'Promocode inwisselen',
            redeemPromoCodeDescription: 'Heeft u een promotie- of cadeaucode? Voer deze hier in om deze toe te passen op uw account of volgende abonnement.',
            subscription: {
                title: 'Abonnement',
                currentPlan: 'Huidig Plan',
                premiumSubscription: 'Premium Abonnement',
                nextRenewal: 'Volgende verlenging:',
                accessUntil: 'Toegang tot:',
                manageInAppStore: 'Je abonnement is gekocht via de App Store. Om het te annuleren of te wijzigen, open Abonnementen in je Apple ID-instellingen op het apparaat waarmee je hebt geabonneerd.',
                manageInPlayStore: 'Je abonnement is gekocht via Google Play. Om het te annuleren of te wijzigen, open Abonnementen in de Google Play Store op het apparaat waarmee je hebt geabonneerd.',
                notSubscribed: 'U bent momenteel niet geabonneerd op een plan.',
                subscribeNow: 'Nu Abonneren',
                findOutMore: 'Meer Weten',
                cancelSubscription: 'Abonnement Opzeggen',
                cancelSubscriptionTitle: 'Abonnement Opzeggen',
                cancelSubscriptionMessage: 'Weet u zeker dat u uw abonnement wilt opzeggen? U verliest toegang tot premium content aan het einde van uw huidige factureringsperiode.',
                keepSubscription: 'Abonnement Behouden',
                toasts: {
                    subscriptionActivated: 'Abonnement Geactiveerd',
                    subscriptionActivatedMessage: 'Welkom bij Premium!',
                    subscriptionFailed: 'Abonnement Mislukt',
                    paymentMethodUpdated: 'Betalingsmethode Bijgewerkt',
                    paymentMethodUpdatedMessage: 'Uw betalingsinformatie is succesvol bijgewerkt',
                    subscriptionCancelled: 'Abonnement Opgezegd',
                    subscriptionCancelledMessage: 'Uw abonnement eindigt aan het einde van de huidige factureringsperiode',
                    cancellationFailed: 'Opzegging Mislukt'
                }
            },
            closeAccount: {
                title: 'Account Sluiten',
                requestDescription: 'Verzoek tot permanent sluiten van uw account. Deze actie kan niet ongedaan worden gemaakt.',
                requestButton: 'Accountsluiting Verzoeken',
                confirmationTitle: 'Weet u zeker dat u uw account wilt deactiveren? Dit zal:',
                confirmationItems: {
                    cancelSubscription: 'Uw actieve abonnement opzeggen (indien aanwezig)',
                    removeCommunications: 'U verwijderen uit alle communicatie',
                    scheduleDeletion: 'Uw gegevens na 30 dagen permanent verwijderen'
                },
                confirmationWarning: 'U kunt uw deactiveringsverzoek binnen 30 dagen op elk moment annuleren. Na deze periode worden uw account en alle bijbehorende gegevens permanent verwijderd.',
                confirmationCheckbox: 'Ik begrijp dat mijn account na 30 dagen permanent wordt verwijderd',
                deactivateAccount: 'Account Deactiveren',
                cancel: 'Annuleren',
                scheduledTitle: 'Accountdeactivatie Gepland',
                scheduledMessage: 'Uw account is gepland voor permanente verwijdering op',
                scheduledWarning: 'Gedurende deze periode kunt u niet inloggen op uw account. Als u van gedachten verandert, kunt u het deactiveringsproces annuleren.',
                cancelDeactivation: 'Accountdeactivatie Annuleren',
                toasts: {
                    deactivationRequested: 'Accountdeactivatie Verzocht',
                    deactivationRequestedMessage: 'Uw account wordt over 30 dagen permanent verwijderd',
                    deactivationFailed: 'Deactivatie Mislukt',
                    deactivationCancelled: 'Deactivatie Geannuleerd',
                    deactivationCancelledMessage: 'Uw account is niet meer gepland voor verwijdering'
                }
            }
        },
        purchases: {
            title: 'Aankoopgeschiedenis',
            noPurchases: 'Geen aankopen gevonden',
            invoice: 'Factuur'
        },
        activity: {
            title: 'Activiteitstijdlijn',
            dateRange: 'Datumbereik',
            activityType: 'Activiteitstype',
            noActivities: 'Geen activiteiten gevonden',
            resume: 'Hervatten',
            loadMore: 'Meer Laden',
            filters: {
                last7Days: 'Laatste 7 dagen',
                last30Days: 'Laatste 30 dagen',
                lastYear: 'Laatste jaar',
                allTime: 'Alle tijd',
                allActivities: 'Alle Activiteiten',
                listening: 'Luisteren',
                purchases: 'Aankopen',
                likes: 'Vind ik leuk',
                bookmarks: 'Bladwijzers'
            },
            types: {
                listenedTo: 'Geluisterd naar {title}',
                purchased: 'Gekocht {title}',
                liked: 'Vind ik leuk {title}',
                bookmarked: 'Bladwijzer {title}'
            }
        },
        appSettings: {
            title: 'App Instellingen',
            darkMode: 'Donkere Modus',
            language: 'Taal',
            languageOptions: {
                english: 'Engels',
                spanish: 'Spaans',
                french: 'Frans',
                german: 'Duits',
                italian: 'Italiaans',
                portuguese: 'Portugees',
                dutch: 'Nederlands',
                slovak: 'Slowaaks',
                russian: 'Russisch',
                arabic: 'العربية'
            }
        },
        notifications: {
            title: 'Meldingen',
            emailNotifications: 'E-mailmeldingen',
            emailNotificationsHint: 'Ontvang updates via e-mail',
            pushNotifications: 'Pushmeldingen',
            pushNotificationsHint: 'Ontvang pushmeldingen',
            updatePreferences: 'Voorkeuren Bijwerken'
        },
        toasts: {
            themeUpdated: 'Thema Bijgewerkt',
            themeUpdatedMessage: 'Uw themavoorkeur is opgeslagen',
            languageUpdated: 'Taal Bijgewerkt',
            languageUpdatedMessage: 'Uw taalvoorkeur is opgeslagen',
            preferencesUpdated: 'Voorkeuren Bijgewerkt',
            preferencesUpdatedMessage: 'Uw meldingsvoorkeuren zijn opgeslagen',
            updateFailed: 'Bijwerken Mislukt',
            updateFailedMessage: 'Fout bij bijwerken van instelling',
            updateFailedNotificationMessage: 'Fout bij bijwerken van meldingsvoorkeuren'
        }
    },
    auth: {
        login: {
            title: 'Inloggen',
            description: 'Log in op uw Heard-account om toegang te krijgen tot uw bibliotheek en premium content',
            signIn: 'Inloggen',
            signInToAccount: 'Log in op uw account',
            noAccount: 'Heeft u geen account?',
            signUp: 'Registreren',
            continueAsGuest: 'Doorgaan als gast',
            or: 'Of',
            agreeToTerms: 'Door in te loggen gaat u akkoord met onze',
            termsOfService: 'Servicevoorwaarden',
            privacyPolicy: 'Privacybeleid'
        },
        register: {
            title: 'Registreren',
            description: 'Maak een nieuw Heard-account aan om toegang te krijgen tot uw bibliotheek en premium content'
        }
    },
    player: {
        chapters: 'Hoofdstukken',
        options: 'Opties',
        playbackSpeed: 'Afspeelsnelheid',
        share: 'Delen',
        linkCopied: 'Link Gekopieerd',
        linkCopiedMessage: 'Deellink gekopieerd naar klembord!',
        shareError: 'Fout bij Delen',
        shareErrorMessage: 'Deellink kon niet worden gekopieerd. Probeer het opnieuw.',
        bookmarkAdded: 'Succes',
        bookmarkAddedMessage: 'Bladwijzer toegevoegd!',
        jumpedToBookmark: 'Succes',
        jumpedToBookmarkMessage: 'Naar bladwijzer gesprongen!',
        likeError: 'Fout bij Favoriet',
        likeErrorMessage: 'Favorietstatus kon niet worden bijgewerkt. Probeer het opnieuw.',
        bookmarkError: 'Fout bij Bladwijzer',
        bookmarkErrorMessage: 'Bladwijzer kon niet worden bijgewerkt. Probeer het opnieuw.',
        favorites: {
            add: 'Toevoegen aan Favorieten',
            remove: 'Verwijderen uit Favorieten'
        },
        unknownChapter: 'Onbekend Hoofdstuk',
        unknownTitle: 'Onbekende Titel',
        unknownAuthor: 'Onbekende Auteur'
    },
    details: {
        starring: 'Hoofdrolspelers:',
        author: 'Auteur',
        narrator: 'Verteller',
        pause: 'Pauzeren',
        purchased: 'Gekocht',
        continueReading: 'Verder Lezen',
        continuePlaying: 'Verder Afspelen',
        play: 'Afspelen',
        loading: 'Laden...',
        noChapters: 'Geen hoofdstukken beschikbaar',
        chapterFreeLabel: 'Gratis',
        listen: 'Luisteren',
        purchaseSuccess: 'Aankoop succesvol',
        purchaseSuccessMessage: '{title} is toegevoegd aan uw bibliotheek',
        subscriptionSuccess: 'Abonnement succesvol',
        subscriptionSuccessMessage: 'Welkom bij Heard Premium!',
        subscriptionFailed: 'Abonnement mislukt',
        subscriptionErrorMessage: 'Er is een fout opgetreden bij het verwerken van uw abonnement.',
        info: 'Info',
        more: 'Meer',
        episodes: 'Afleveringen',
        about: 'Over',
        series: 'Serie',
        producedBy: 'Geproduceerd door',
        recommendations: 'Misschien vind je dit ook leuk',
        moreFromCategory: 'Meer van {name}',
        moreFromAuthor: 'Meer van {name}',
        moreFromCast: 'Meer van {name}',
        moreFromSeries: 'Meer in {name}',
        noRelated: 'Geen gerelateerde titels beschikbaar op dit moment.',
        ageVerification: {
            title: 'Alleen voor volwassenen',
            message: 'Deze inhoud is alleen voor volwassenen. Bevestig dat je wilt doorgaan.',
            minAgeHint: 'Je moet minstens {age} jaar zijn om deze titel te bekijken.',
            confirm: 'Ik ben volwassen, doorgaan',
            cancel: 'Annuleren',
            missingDobTitle: 'Geboortedatum vereist',
            missingDobMessage: 'Voeg je geboortedatum toe in je profiel om deze inhoud te bekijken.',
            underageTitle: 'Leeftijdsbeperking',
            underageMessage: 'Je moet minstens {age} jaar zijn om deze inhoud te bekijken.',
        },
    },
    shareModal: {
        title: 'Delen',
        copyLink: 'Link kopiëren',
        copyLinkWithMessage: 'Link met bericht kopiëren',
        copyLinkWithMessageHint: 'Titel en beschrijving inbegrepen',
        shareVia: 'Delen via...',
        shareViaHint: 'Apps, berichten, e-mail',
        linkCopied: 'Link gekopieerd',
        linkCopiedMessage: 'Link gekopieerd naar klembord!',
        shared: 'Gedeeld',
        sharedMessage: 'Inhoud succesvol gedeeld'
    },
    contextMenu: {
        playFromBeginning: 'Vanaf Begin Afspelen',
        markAsFinished: 'Markeren als Voltooid',
        addToFavorites: 'Toevoegen aan Favorieten',
        removeFromFavorites: 'Verwijderen uit Favorieten',
        share: 'Delen',
        viewDetails: 'Details Bekijken',
        removeFromLibrary: 'Verwijderen uit Bibliotheek',
        continuePlaying: 'Verder Afspelen',
        continueReading: 'Verder Lezen'
    },
    actions: {
        subscribe: 'Abonneren',
        signInToGetPremium: 'Premium krijgen',
        purchase: 'Kopen',
        buy: 'Kopen',
        buyFor: 'Kopen voor {price}',
        purchasedGoToLibrary: 'Gekocht - Naar Bibliotheek',
        addToFavorites: 'Toevoegen aan favorieten',
        removeFromFavorites: 'Verwijderen uit favorieten',
        share: 'Delen'
    },
    browse: {
        sortBy: 'Sorteren op',
        sortOptions: {
            recent: 'Recente',
            ascending: 'A-Z',
            descending: 'Z-A'
        }
    },

    legal: {
        companyNumber: 'KvK-nummer',
        privacyPolicy: 'Privacybeleid',
        termsOfService: 'Gebruiksvoorwaarden',
        agreeToTermsSubscribe: 'Door te abonneren gaat u akkoord met onze',
        operatedBy: '{appName} wordt beheerd door {companyName}, {address}',
        faqs: 'Veelgestelde vragen'
    },
    support: {
        title: 'Support',
        description: 'Hulp nodig met uw account, abonnement of luisterervaring? Bekijk onze FAQ\'s en juridische informatie, of neem contact met ons op.',
        intro: 'Hulp nodig met uw account, abonnement of luisterervaring? Bekijk onze FAQ\'s en juridische informatie hieronder, of neem contact met ons op als u meer hulp nodig heeft.',
        quickLinks: 'Snelle links',
        contactTitle: 'Contact opnemen met support',
        contactDescription: 'Stuur een bericht naar ons supportteam. Bekijk eerst de FAQ\'s voor snelle antwoorden.',
        contactIntro: 'Als u hulp nodig heeft, staan wij voor u klaar. Veel veelgestelde vragen worden al beantwoord in ons helpcentrum.',
        contactIntroFaqBefore: 'Bekijk onze ',
        contactIntroFaqAfter: ' voor antwoorden op veelgestelde vragen. Als u nog steeds hulp nodig heeft, vul het formulier in en we nemen zo snel mogelijk contact met u op.',
        contactSubmit: 'Bericht verzenden',
        contactName: 'Naam',
        contactEmail: 'E-mail',
        contactSubject: 'Onderwerp',
        contactMessage: 'Bericht',
        contactMessageHint: 'Beschrijf uw probleem in detail',
        backToSupport: 'Terug naar support',
        pageLoading: 'Laden…',
        pageNotAvailable: 'Deze pagina is momenteel niet beschikbaar.',
        unsupportedSection: 'Niet-ondersteunde inhoudssectie: {name}',
        useContactFormBefore: 'Wilt u contact opnemen? Gebruik ons ',
        contactSuccessTitle: 'Bericht verzonden',
        contactSuccessMessage: 'Uw bericht is verzonden. We nemen zo snel mogelijk contact op.',
        contactErrorTitle: 'Verzenden mislukt',
        contactErrorMessage: 'Uw bericht kon niet worden verzonden. Probeer het opnieuw.'
    },
    promo: {
        haveCode: 'Heeft u een promocode?',
        placeholder: 'Voer code in',
        apply: 'Toepassen',
        remove: 'Verwijderen',
        applied: '{name} – {discount}',
        invalidCode: 'Ongeldige of verlopen code.',
        expired: 'Deze code is verlopen.',
        notValidForPurchase: 'Deze code is niet geldig voor deze aankoop.',
        free: 'Gratis',
        percentOff: '{value}% korting',
        fixedOff: '{value} korting',
        useWhenSubscribe: 'Gebruik deze aanbieding wanneer u hieronder abonneert.',
        useWhenPurchase: 'Gebruik deze code bij het kopen van een titel.',
        accessGranted: 'Toegang is toegepast op uw account.'
    }
}

export default messages

